import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./modules/boot/App";
import "./i18n";
import { IpProvider } from "./services/ip_provider";
import { ModalStack } from "./core/ModalStack";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <IpProvider>
    <ModalStack />
    <App />
  </IpProvider>
);
